export default "__VITE_ASSET__BrS1zsZR__"